import styled from 'styled-components';
import { Link } from '../../../../common/components/Link';
import { ChevronRight } from '../../../../common/components/icons/ChevronRight';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { FONT_STACK } from '../../../../common/styles/constants';

export interface Props {
  profileId?: string;
}

export const appBaseLink = 'https://he.app.link/xh26taPjz4';

export const OpenInAppBanner = ({ profileId }: Props) => {
  const toLink = profileId ? appBaseLink + '?practice=' + profileId : appBaseLink;

  return (
    <StyledLink to={toLink}>
      <StyledDiv>
        Open in Healthengine app
        <ChevronRight height={24} width={24} />
      </StyledDiv>
    </StyledLink>
  );
};

export const OPEN_IN_APP_HEIGHT = 56;

const StyledDiv = styled.div`
  align-items: center;
  background-color: ${ThemeColours.buttonPrimaryFill};
  display: flex;
  height: ${OPEN_IN_APP_HEIGHT}px;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  ${FONT_STACK};
  align-items: center;
  color: ${ThemeColours.buttonPrimaryText};
  font-size: 16px;
  text-decoration: none;
  width: 100%;
`;
